module.exports = __webpack_public_path__ + "static/media/2NationalMuseumofMalaysia.c35906ab.png";